module.exports = __webpack_public_path__ + "img/error.b5bfd9ac.svg";